const settings = {
    host: (process.env.NODE_ENV==='development')? 'https://localhost:5001' : 'https://smakkidapi.azurewebsites.net'
};
export default settings;